import React, { useState, useCallback } from "react";

import axios from "~/config/axios";
import { createFreePurchase } from "~/lib/createFreePurchase";
import { createCheckoutSession } from "~/lib/createCheckoutSession";
import { validateDiscount } from "~/lib/validateDiscount";
import { CheckoutDropInPopupView } from "./CheckoutDropInPopup.view";
import { login } from "~/lib/login";
import { useStore } from "~/hooks/useStore";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

export function CheckoutDropInPopup(props) {
  const {
    course,
    earlyAccess,
    locations,
    onClose,
    onOpenWaitingListPopup,
    session,
    ticketType,
    tutors
  } = props;

  const { executeRecaptcha } = useGoogleReCaptcha();
  const [{ user }] = useStore("authentication");
  const [isAlreadyBooked, setIsAlreadyBooked] = useState(false);

  async function onCheckoutLogin() {
    return await login();
  }

  async function onConfirmFreeBooking(data) {
    try {
      if (!executeRecaptcha) throw "Execute recaptcha not yet available";

      const recaptchaToken = await executeRecaptcha(
        "MarketplaceRegularCHECKOUTFree"
      );
      let checkoutData = {
        ...data,
        recaptchaToken,
        isDropIn: true
      };
      await createFreePurchase(checkoutData, onPurchase);
    } catch (e) {
      console.error(e.message);
    }
  }

  async function onGetPaymentIntent(data) {
    try {
      if (!executeRecaptcha) throw "Execute recaptcha not yet available";

      const recaptchaToken = await executeRecaptcha(
        "MarketplaceRegularCHECKOUT"
      );
      let checkoutData = {
        ...data,
        recaptchaToken,
        isDropIn: true
      };
      return await createCheckoutSession(checkoutData);
    } catch (e) {
      throw e.response?.data?.message ?? e.message ?? "Something went wrong";
    }
  }

  async function onLoadMoreDates({ page, limit }) {
    const response = await axios.get(`courses/${course._id}/drop-in-dates`, {
      params: { page, limit, earlyAccess }
    });
    return response.data;
  }

  function onPurchase(purchase, price = 0) {
    let dataTrack = {
      school: window.location.pathname.split("/")[1],
      event: "Order Completed",
      event_category: "purchase",
      event_label: "purchase",
      value: price / 100,
      order_id: purchase._id,
      email: purchase.bookingData.user.renderEmail,
      total: price / 100,
      currency: purchase.bookingData.currencyUsed,
      products: [
        {
          course_id: purchase.bookingData.courseId
        }
      ]
    };
    if (window.dataLayer) {
      window.dataLayer.push(dataTrack);
    }
  }

  async function onValidateDiscount(code, email) {
    return await validateDiscount(code, email, course._id, course.schoolId);
  }
  return (
    <CheckoutDropInPopupView
      course={course}
      locations={locations}
      onCheckoutLogin={onCheckoutLogin}
      onClose={onClose}
      onConfirmFreeBooking={onConfirmFreeBooking}
      onGetPaymentIntent={onGetPaymentIntent}
      onLoadMoreDates={onLoadMoreDates}
      onOpenWaitingListPopup={onOpenWaitingListPopup}
      onValidateDiscount={onValidateDiscount}
      session={session}
      ticketType={ticketType}
      tutors={tutors}
      user={user}
    />
  );
}

CheckoutDropInPopup.propTypes = {};
